module.exports = __webpack_public_path__ + "static/media/filtro-data-icon.5c0bf80a.svg";